import { useEffect, useState } from "react";
import Footer from "../../common/footer/Footer";
import Header from "../../common/header/Header";
import Home_Private_Confidential from "../home_page_components/home_private_confidential/Home_Private_Confidential";
import { Get_Astrology_data } from "../../../api/global/Global";
import parse from 'html-react-parser';
import Loader from "../../../loader/Loader";
import Kundli_Main_Banner from "../kundli/kundli_main_bannner/Kundli_Main_Banner";
import { Helmet } from "react-helmet";
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from "../../../config/Config";
import { useNavigate, useParams } from "react-router-dom";
import Kundli_Common_Section from "../kundli/kundli_common_section/Kundli_Common_Section";
import { toast } from "react-toastify";
import Free_Get_Kundli_Form from "../kundli/free_kundli/Free_Get_Kundli_Form";
import Common_Images_Transport from "../../common/common_imges_transport/Common_Images_Transport";
import Horoscope from "../kundli/horoscope/Horoscope";
import { isAlphabetical } from "../../validation/Validation";

export const ImportantPageLayout = () => {
    const navigate = useNavigate()
    const { slug } = useParams()
    const [astrology_data, set_AstrologyData] = useState({});
    const [is_loading, set_Is_Loading] = useState(false)
    const [love_calculator_form, set_Love_Calculator_Form] = useState({
        name: "",
        your_gender: "",
        partner_name: "",
        partner_gender: ""
    })
    const [errorMessage, setErrorMessage] = useState('');


    // <------------panchang-form-handling---------->

    const [panchangform, setPanchangeForm] = useState({
        location: "",
        date: ""
    })

    const handlePanchangeChange = (e) => {
        const { name, value } = e.target;
        setPanchangeForm({
            ...panchangform,
            [name]: value
        })
    }

    const HandleSubmit = (e) => {
        e.preventDefault();
        if (!panchangform.location) {
            toast("Please enter your location ")
            return;
        }
        if (!panchangform.date) {
            toast("Please select the panchang date")
            return;
        }
        try {

        } catch (error) {

        }

    }
    // <---------panchangformhandling------------->

    // <-------------kundali matching form------------->
    const [boys_Detail, set_Boys_detail] = useState({
        name: '',
        date_time: "",
        birth_place: ''
    })

    const [girl_Detail, set_Girl_Detail] = useState({
        name: '',
        date_time: "",
        birth_place: ''
    })

    const handle_BoyDetail = (e) => {
        setErrorMessage("");
        const { name, value } = e.target
        if (name === "name" && value && !isAlphabetical(value)) {
            setErrorMessage("Name should only contain alphabetic characters");
            return;
        }
        set_Boys_detail((prev) => ({
            ...prev,
            [name]: value,
        }));
    }

    const handle_GirlDetail = (e) => {
        setErrorMessage("");
        const { name, value } = e.target
        if (name === "name" && value && !isAlphabetical(value)) {
            setErrorMessage("Name should only contain alphabetic characters");
            return;
        }
        set_Girl_Detail((prev) => ({
            ...prev,
            [name]: value,
        }));
    }

    // submit form function
    const handle_Submit = (e) => {
        e.preventDefault();
        if (!boys_Detail.name) {
            toast("Please enter boy's name");
            return;
        }
        if (!boys_Detail.date_time) {
            toast("Please select boy's date & time");
            return;
        }
        if (!boys_Detail.birth_place) {
            toast("Please enter boy's birth place");
            return;
        }
        if (!girl_Detail.name) {
            toast("Please enter girl's name");
            return;
        }
        if (!girl_Detail.date_time) {
            toast("Please select girl's date & time");
            return;
        }
        if (!girl_Detail.birth_place) {
            toast("Please enter girl's birth place");
            return;
        }
        try {

        } catch (error) {

        }

        alert("Submit form");
    };
    // <-------------kundali matching form------------->


    // <--------------- Love Calculator onchnage section's ----------->
    const HandleLoveCalclatorChange = (e) => {
        setErrorMessage("");
        const { name, value } = e.target;
        if (name === "name" && value && !isAlphabetical(value)) {
            setErrorMessage("Name should only contain alphabetic characters");
            return;
        }
        if (name === "partner_name" && value && !isAlphabetical(value)) {
            setErrorMessage("Name should only contain alphabetic characters");
            return;
        }
        set_Love_Calculator_Form({
            ...love_calculator_form,
            [name]: value
        })
    }

    // <--------------- Submit the Love Calculator Form -------------->
    const HandleSubmitLoveCalculator = (e) => {
        e.preventDefault();
        if (!love_calculator_form.name) {
            toast("please enter your name")
            return;
        }
        else if (!love_calculator_form.your_gender) {
            toast("please select your gender")
            return;
        }
        else if (!love_calculator_form.partner_name) {
            toast("please enter your partner name ")
            return;
        }
        else if (!love_calculator_form.partner_gender) {
            toast("please select your partner's gender ")
            return;
        }
        try {

        } catch (error) {

        }
    }


    useEffect(() => {
        const Handle_Get_Astrology_data = async () => {
            set_Is_Loading(true)
            try {
                const response = await Get_Astrology_data(slug);
                if (response?.data?.status == 200) {
                    set_AstrologyData(response?.data?.data?.astrology)
                }
                if (response?.response?.data?.status == 500) {
                    toast.error(response?.response?.data?.message)
                    navigate("/")
                }
            } catch (error) {
                console.error("error", error)
            } finally {
                set_Is_Loading(false)
            }
        }
        if (slug) {  // make sure slug exists before calling
            Handle_Get_Astrology_data();
        }
    }, [slug])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            {
                is_loading ? (
                    <Loader />
                ) : (
                    <>
                        <Helmet>
                            <title>{astrology_data?.meta_title}</title>
                            <meta name="description" content={astrology_data?.meta_description} />

                            <link rel="canonical" href={`${WEB_DOMAIN_KEY}page/${astrology_data?.slug}`} />
                            <link rel="alternate" hreflang="en-us" href={`${WEB_DOMAIN_KEY}page/${astrology_data?.slug}`} />

                        </Helmet>

                        <Header />
                        {/* <------------ Kundli_Main_Banner ---------> */}
                        < Kundli_Main_Banner banner={{ banner: astrology_data?.banner, alt: astrology_data?.alt }} />
                        {
                            astrology_data?.page_name === "how-to-read-kundli" && (
                                <section className="gi-faq py-[40px] max-[767px]:py-[30px]">
                                    <div className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                        <h1 className="text-2xl font-semibold">{astrology_data?.title}</h1>
                                        <div className="custome_viewbox">
                                            <p className="text-gray-700 mb-4 sub__title">{astrology_data?.description
                                                ? parse(String(astrology_data.description))
                                                : ""}</p>
                                        </div>
                                    </div>
                                </section>
                            )
                        }
                        {
                            astrology_data?.page_name === "panchang" && (
                                <>
                                    <section className="gi-category py-[40px] max-[767px]:p-[15px] bg-[#F0F4F8]">
                                        <div
                                            className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                            <div className="kundli_form w-full mt-6">
                                                <div className="flex flex-wrap w-full">
                                                    <div
                                                        className="min-[992px]:w-[66.33%] flex min-[768px]:w-[50%] min-[576px]:w-[50%] max-[420px]:w-full max-[575px]:w-[50%] max-[575px]:mx-auto pr-6">
                                                        <div className="bg-white w-full">
                                                            <div className="p-4 border-b">
                                                                <h1 className="mb-1 text-2xl font-semibold text-gray-900">{astrology_data?.title}</h1>
                                                                <p className="text-gray-700">Generate panchang using Ayanamsa, place, date</p>
                                                            </div>
                                                            <form accept="#" method="post" onSubmit={HandleSubmit}>
                                                                <div className="py-5 pl-6 pr-6">
                                                                    <div className="input-grid flex space-x-2.5 mb-6">
                                                                        <div className="w-4/5 h-full">
                                                                            <div className="input-com "><label
                                                                                className="input-label capitalize block  mb-2 text-qgray text-[13px] font-normal">Location</label>
                                                                                <div
                                                                                    className="input-wrapper border border-qgray-border  overflow-hidden relative ">
                                                                                    <input placeholder="Location" value={panchangform.location} name='location'
                                                                                        onChange={handlePanchangeChange}
                                                                                        className="input-field placeholder:text-sm text-sm px-6 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[45px]"
                                                                                        type="text" />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="w-1/2 h-full">
                                                                            <div className="input-com ">
                                                                                <label
                                                                                    className="input-label capitalize block  mb-2 text-qgray text-[13px] font-normal">Date</label>
                                                                                <div
                                                                                    className="input-wrapper border border-qgray-border  overflow-hidden relative ">
                                                                                    <input placeholder="Location" value={panchangform.date} name='date'
                                                                                        onChange={handlePanchangeChange}
                                                                                        className="input-field w-full placeholder:text-sm text-sm px-6 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[45px]"
                                                                                        type="Date" />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="w-1/2 h-full mt-auto">
                                                                            <div className="input-com ">
                                                                                <button type="submit"
                                                                                    className="w-[100%] h-[45px] bg-[#9F2225] text-white text-sm">Get Result</button>
                                                                            </div>
                                                                        </div>

                                                                    </div>

                                                                </div>
                                                            </form>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="bg-white min-[992px]:w-[33.33%] min-[768px]:w-[50%] min-[576px]:w-[50%] max-[420px]:w-full max-[575px]:w-[50%] max-[575px]:mx-auto">
                                                        <img src={`${IMG_BASE_URL}${astrology_data?.image}`} alt={astrology_data?.alt} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='mt-6'>
                                                <p className="text-gray-700 sub__title">{astrology_data?.description
                                                    ? parse(String(astrology_data.description))
                                                    : ""}</p>
                                            </div>
                                        </div>

                                    </section>
                                    {/* <----------- Kundli_Common_Section -------------->  */}
                                    <Kundli_Common_Section />
                                </>
                            )}

                        {
                            astrology_data?.page_name === "free-kundli" && (
                                <>
                                    {/* <!--  Free Kundli section --> */}
                                    <section className="gi-category py-[40px] max-[767px]:p-[15px] bg-[#F0F4F8]">
                                        <div
                                            className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                            <div className="flex flex-wrap w-full">
                                                <div className="w-full md:flex lg:flex bg-white p-5 gap-6">
                                                    <div className="kundliimg flex">
                                                        <img src={`${IMG_BASE_URL}${astrology_data?.image}`} className="max-w-[200px]" alt={astrology_data?.alt} />
                                                    </div>
                                                    <div className="kundli_info">
                                                        <h1 className="text-2xl font-semibold mb-2 text-gray-700">{astrology_data?.title}</h1>
                                                        <p className="text-gray-700 sub__title">{astrology_data?.short_description
                                                            ? parse(String(astrology_data.short_description))
                                                            : ""}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* <---------- Free Get janam Kundli form -----------> */}
                                            <Free_Get_Kundli_Form />

                                            <div className="flex flex-wrap w-full pt-8">
                                                <div className="w-full">

                                                    <div className="kundli_info">
                                                        <p className="text-gray-700 mb-4 sub__title">{astrology_data?.description
                                                            ? parse(String(astrology_data.description))
                                                            : ""}</p>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </section>

                                    {/* <------------ Kundli Common section's ------------> */}
                                    <Kundli_Common_Section />
                                </>
                            )}

                        {
                            astrology_data?.page_name === "kundli-matching" && (
                                <>
                                    {/* <!--  Free Kundli section --> */}
                                    <section className="gi-category py-[40px] max-[767px]:p-[15px] bg-[#F0F4F8]">
                                        <div
                                            className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                            <div className="flex flex-wrap w-full">
                                                <div className="w-full md:flex lg:flex bg-white p-5 gap-6">
                                                    <div className="kundliimg flex">
                                                        <img src={`${IMG_BASE_URL}${astrology_data?.image}`} className="max-w-[200px]" alt={astrology_data?.alt} />
                                                    </div>
                                                    <div className="kundli_info">
                                                        <h1 className="text-2xl mb-2 font-semibold text-gray-900">{astrology_data?.title}</h1>
                                                        <p className="text-gray-700 sub__title">{astrology_data?.short_description
                                                            ? parse(String(astrology_data?.short_description))
                                                            : ""}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="kundli_form w-full mt-6">
                                                <form accept="#" method="post">
                                                    <div className="flex flex-wrap w-full">
                                                        <div
                                                            className="min-[992px]:w-[50%%] flex min-[768px]:w-[50%] min-[576px]:w-[50%] max-[420px]:w-full max-[575px]:w-[50%] max-[575px]:mx-auto pr-6">
                                                            <div className="bg-white w-full">
                                                                <h2 className="mb-2 text-xl font-semibold text-gray-900 p-4 border-b flex items-center gap-4"><img src={Common_Images_Transport?.boys_icon} alt="" /> Enter Boy's Details</h2>
                                                                <div className="py-5 pl-6 pr-6">
                                                                    <div className="input-grid flex space-x-2.5 mb-6">
                                                                        <div className="w-full">
                                                                            <div className="input-com "><label
                                                                                className="input-label capitalize block  mb-2 text-qgray text-[13px] font-normal">
                                                                                Name*</label>
                                                                                <div
                                                                                    className="input-wrapper border border-qgray-border  overflow-hidden relative ">
                                                                                    <input name="name" placeholder="Name"
                                                                                        className="input-field placeholder:text-sm text-sm px-6 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[50px]"
                                                                                        type="text" value={boys_Detail?.name} onChange={handle_BoyDetail} />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="input-grid flex space-x-2.5 mb-6">
                                                                        <div className="w-1/2 h-full">
                                                                            <div className="input-com "><label
                                                                                className="input-label capitalize block  mb-2 text-qgray text-[13px] font-normal">Birth
                                                                                Date and Time Details</label>
                                                                                <div
                                                                                    className="input-wrapper border border-qgray-border  overflow-hidden relative ">
                                                                                    <input name="date_time" placeholder="datetime-local"
                                                                                        className="input-field w-full placeholder:text-sm text-sm px-6 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[50px]"
                                                                                        type="datetime-local" value={boys_Detail?.date_time} max={new Date().toISOString().slice(0, 16)} onChange={handle_BoyDetail} />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="w-1/2 h-full">
                                                                            <div className="input-com "><label
                                                                                className="input-label capitalize block  mb-2 text-qgray text-[13px] font-normal">Birth
                                                                                Place*</label>
                                                                                <div
                                                                                    className="input-wrapper border border-qgray-border  overflow-hidden relative ">
                                                                                    <input name='birth_place' placeholder="Birth Place*"
                                                                                        className="input-field placeholder:text-sm text-sm px-6 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[50px]"
                                                                                        type="text" value={boys_Detail?.birth_place} onChange={handle_BoyDetail} />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            className="min-[992px]:w-[50%] flex min-[768px]:w-[50%] min-[576px]:w-[50%] max-[420px]:w-full max-[575px]:w-[50%] max-[575px]:mx-auto">
                                                            <div className="bg-white w-full">
                                                                <h2 className="mb-2 text-xl font-semibold text-gray-900 p-4 border-b flex items-center gap-4"><img src={Common_Images_Transport?.girl_icon} alt="" /> Enter Girl's Details</h2>
                                                                <div className="py-5 pl-6 pr-6">
                                                                    <div className="input-grid flex space-x-2.5 mb-6">
                                                                        <div className=" w-full">
                                                                            <div className="input-com "><label
                                                                                className="input-label capitalize block  mb-2 text-qgray text-[13px] font-normal">
                                                                                Name*</label>
                                                                                <div
                                                                                    className="input-wrapper border border-qgray-border  overflow-hidden relative ">
                                                                                    <input name='name' placeholder="Name"
                                                                                        className="input-field placeholder:text-sm text-sm px-6 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[50px]"
                                                                                        type="text" value={girl_Detail?.name} onChange={handle_GirlDetail} />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="input-grid flex space-x-2.5 mb-6">
                                                                        <div className="w-1/2 h-full">
                                                                            <div className="input-com "><label
                                                                                className="input-label capitalize block  mb-2 text-qgray text-[13px] font-normal">Birth
                                                                                Date and Time Details</label>
                                                                                <div
                                                                                    className="input-wrapper border border-qgray-border  overflow-hidden relative ">
                                                                                    <input name='date_time' placeholder="datetime-local"
                                                                                        className="input-field w-full placeholder:text-sm text-sm px-6 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[50px]"
                                                                                        type="datetime-local" value={girl_Detail?.date_time} max={new Date().toISOString().slice(0, 16)} onChange={handle_GirlDetail} />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="w-1/2 h-full">
                                                                            <div className="input-com "><label
                                                                                className="input-label capitalize block  mb-2 text-qgray text-[13px] font-normal">Birth
                                                                                Place*</label>
                                                                                <div
                                                                                    className="input-wrapper border border-qgray-border  overflow-hidden relative ">
                                                                                    <input name='birth_place' placeholder="Birth Place*"
                                                                                        className="input-field placeholder:text-sm text-sm px-6 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[50px]"
                                                                                        type="text" value={girl_Detail?.birth_place} onChange={handle_GirlDetail} />
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="input-grid mt-5 w-full">
                                                            <div className="w-full text-center">
                                                                <div className="input-com "><button type="button"
                                                                    className="w-[300px] h-[45px] bg-[#9F2225] text-white text-sm">Match Kundli</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>

                                            <div className="flex flex-wrap w-full pt-8">
                                                <div className="w-full">
                                                    <div className="kundli_info">
                                                        <p className="text-gray-700 mb-3 sub__title">{astrology_data?.description
                                                            ? parse(String(astrology_data?.description))
                                                            : ""}</p>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </section>
                                    {/* <----------- Kundli_Common_Section ------------> */}
                                    <Kundli_Common_Section />
                                </>
                            )}

                        {
                            astrology_data?.page_name === "kaalsarp-doshas" && (
                                <section className="gi-faq py-[40px] max-[767px]:py-[30px]">
                                    <div
                                        className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                        <h1 className="text-2xl mb-2 font-semibold text-gray-900">{astrology_data?.title}</h1>
                                        <div className="custome_viewbox">
                                            <p className="text-gray-700 mb-4 sub__title">{astrology_data?.description
                                                ? parse(String(astrology_data.description))
                                                : ""}</p>

                                        </div>
                                    </div>
                                </section>
                            )}
                        {
                            astrology_data?.page_name === "nakshatras-constellations" && (
                                <section className="gi-faq py-[40px] max-[767px]:py-[30px]">
                                    <div
                                        className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                        <h1 className="text-2xl mb-2 font-semibold text-gray-900">{astrology_data?.title}</h1>
                                        <div className="custome_viewbox">
                                            <p className="text-gray-700 mb-4 sub__title">{astrology_data?.description
                                                ? parse(String(astrology_data.description))
                                                : ""}</p>
                                        </div>
                                    </div>
                                </section>
                            )}
                        {
                            astrology_data?.page_name === "numerology" && (
                                <section className="gi-faq py-[40px] max-[767px]:py-[30px]">
                                    <div
                                        className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                        <h1 className="text-2xl mb-2 font-semibold text-gray-900">{astrology_data?.title}</h1>
                                        <div className="custome_viewbox">
                                            <p className="text-gray-700 mb-4 sub__title">{astrology_data?.description
                                                ? parse(String(astrology_data.description))
                                                : ""}</p>
                                        </div>
                                    </div>
                                </section>
                            )}
                        {
                            astrology_data?.page_name === "astrology-yoga" && (
                                <section className="gi-faq py-[40px] max-[767px]:py-[30px]">
                                    <div
                                        className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                        <h1 className="text-2xl mb-2 font-semibold text-gray-900">{astrology_data?.title}</h1>
                                        <div className="custome_viewbox">
                                            <p className="text-gray-700 mb-4 sub__title">{astrology_data?.description
                                                ? parse(String(astrology_data.description))
                                                : ""}</p>
                                        </div>
                                    </div>
                                </section>
                            )}
                        {
                            astrology_data?.page_name === "child-astrology" && (
                                <section className="gi-faq py-[40px] max-[767px]:py-[30px]">
                                    <div className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                        <h1 className="text-2xl mb-2 font-semibold text-gray-900">{astrology_data?.title}</h1>
                                        <div className="custome_viewbox">
                                            <p className="text-gray-700 mb-4 sub__title">{astrology_data?.description
                                                ? parse(String(astrology_data.description))
                                                : ""}</p>
                                        </div>
                                    </div>
                                </section>
                            )}
                        {
                            astrology_data?.page_name === "love-calculator" && (
                                <>
                                    <section className="gi-category py-[40px] max-[767px]:p-[15px] bg-[#F0F4F8]">
                                        <div
                                            className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                            <div className="kundli_form w-full mt-6">


                                                <div className="flex flex-wrap w-full">
                                                
                                                    <div className="w-full lg:w-[70%] pr-0 lg:pr-6">
  <div className="bg-white w-full">
    <div className="p-4 border-b">
      <h1 className="mb-1 text-2xl font-semibold text-gray-900">
        {astrology_data?.title}
      </h1>
      <p className="text-gray-700 sub__title">
        {astrology_data?.short_description
          ? parse(String(astrology_data.short_description))
          : ""}
      </p>
    </div>

    <form accept="#" method="post" onSubmit={HandleSubmitLoveCalculator}>
      <div className="py-5 px-6">
        {errorMessage && (
          <p className="text-red-500 text-sm mb-2">{errorMessage}</p>
        )}

        {/* INNER FORM ROW */}
        <div className="flex flex-col md:flex-row md:space-x-2.5 space-y-6 md:space-y-0 mb-6">

          {/* YOUR NAME */}
          <div className="w-full md:w-1/2 h-full">
            <div className="input-com">
              <label className="input-label capitalize block mb-2 text-qgray text-[13px] font-normal">
                Your Name
              </label>

              <div className="input-wrapper border border-qgray-border overflow-hidden relative">
                <input
                  placeholder="Enter Name"
                  className="input-field w-full placeholder:text-sm text-sm px-6 text-dark-gray font-normal bg-white focus:ring-0 focus:outline-none h-[45px]"
                  type="text"
                  value={love_calculator_form.name}
                  name="name"
                  onChange={HandleLoveCalclatorChange}
                />
              </div>

              <div className="flex gap-4 mt-4">
                <div className="flex items-center">
                  <input
                    id="default-radio-1"
                    type="radio"
                    value="male"
                    name="your_gender"
                    onChange={HandleLoveCalclatorChange}
                    className="w-4 h-4"
                  />
                  <label htmlFor="default-radio-1" className="ms-2 text-sm">
                    Male
                  </label>
                </div>

                <div className="flex items-center">
                  <input
                    id="default-radio-2"
                    type="radio"
                    value="female"
                    name="your_gender"
                    onChange={HandleLoveCalclatorChange}
                    className="w-4 h-4"
                  />
                  <label htmlFor="default-radio-2" className="ms-2 text-sm">
                    Female
                  </label>
                </div>
              </div>
            </div>
          </div>

          {/* HEART IMAGE (INSIDE FORM) */}
          <div className="w-full md:w-auto flex justify-center items-center">
            <img
              src={Common_Images_Transport?.love_calendar}
              className="mx-auto max-w-[120px] md:max-w-full"
              alt=""
            />
          </div>

          {/* PARTNER NAME */}
          <div className="w-full md:w-1/2 h-full">
            <div className="input-com">
              <label className="input-label capitalize block mb-2 text-qgray text-[13px] font-normal">
                Partner&apos;s Name
              </label>

              <div className="input-wrapper border border-qgray-border overflow-hidden relative">
                <input
                  placeholder="Enter Name"
                  className="input-field w-full placeholder:text-sm text-sm px-6 text-dark-gray font-normal bg-white focus:ring-0 focus:outline-none h-[45px]"
                  type="text"
                  value={love_calculator_form.partner_name}
                  name="partner_name"
                  onChange={HandleLoveCalclatorChange}
                />
              </div>

              <div className="flex gap-4 mt-4">
                <div className="flex items-center">
                  <input
                    id="default-radio-3"
                    type="radio"
                    value="male"
                    name="partner_gender"
                    onChange={HandleLoveCalclatorChange}
                    className="w-4 h-4"
                  />
                  <label htmlFor="default-radio-3" className="ms-2 text-sm">
                    Male
                  </label>
                </div>

                <div className="flex items-center">
                  <input
                    id="default-radio-4"
                    type="radio"
                    value="female"
                    name="partner_gender"
                    onChange={HandleLoveCalclatorChange}
                    className="w-4 h-4"
                  />
                  <label htmlFor="default-radio-4" className="ms-2 text-sm">
                    Female
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* BUTTON */}
        <div className="flex">
          <div className="w-full md:w-1/2">
            <button
              type="submit"
              className="w-full md:w-[320px] h-[45px] bg-[#9F2225] text-white text-sm"
            >
              Calculate Love Percentage
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

                                                
                                                
                                                   <div className="bg-white w-full lg:w-[30%] mt-6 lg:mt-0">
  <img
    src={`${IMG_BASE_URL}${astrology_data?.image}`}
    className="w-full"
    alt={astrology_data?.alt}
  />
</div>




                                                    <p className="text-gray-700 sub__title mt-6">{astrology_data?.description
                                                        ? parse(String(astrology_data.description))
                                                        : ""}</p>
                                                    <div
                                                        className="w-full mt-12">

                                                        <h2
                                                            className="gi-pro-stitle border-b border-gray-100 pb-4 font-normal text-[#9F2225] text-xl font-semibold leading-[1.2] capitalize">
                                                            Horoscopes</h2>
                                                        <div className="w-full grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6">
                                                            {/* <---------- Horoscope ---------------> */}
                                                            <Horoscope />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                    {/*  */}
                                    <Kundli_Common_Section />
                                </>
                            )}
                        <Home_Private_Confidential />
                        <Footer />
                    </>
                )}
        </div>
    );
}